<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Color Family {{ (inputName) ? (" - " + this.inputName) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4">View Color Family - {{this.inputName}}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Color Family - {{this.inputName}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <base-input alternative="" label="Code" placeholder="" v-model="inputCode" input-classes="form-control"/>
            <base-input alternative="" label="Name" placeholder="" v-model="inputName" input-classes="form-control" required />
            <base-input type="number" alternative="" label="Sequence" placeholder="" v-model="inputSequence" input-classes="form-control" />

            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button>
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button>
                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button>
                </div>
            </div>
        </form>
    </div>
</template>


<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import { mapState } from 'vuex'
    var component_x;
    export default {
        computed: {
            ...mapState(['endPoint', 'profileId', 'parentId', 'serverType']),
        },
        mounted: async function () {
            if(this.serverType == 'branch' || this.$attrs.viewMode == true){
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }
            component_x = this
            if (component_x.profileId > 0){
                var color_family_data = await HTTPRequest.getRequest(component_x.endPoint + 'color_families/' + component_x.profileId, null)
                if(color_family_data == undefined){
                    component_x.$router.go()
                } else {
                    if(color_family_data["error"] == undefined){
                        component_x.inputName = color_family_data["name"]
                        component_x.inputCode = color_family_data["code"]
                        component_x.inputSequence = color_family_data["sequence_no"]
                    } else {
                        this.errors = color_family_data["error"].split(",");
                    }
                }
            }
        },
        data: function () {
            return {
                inputName: '',
                inputCode: '',
                inputSequence: '1',
                errors: []
            }
        },
        methods: {
            validateForm(){
                this.errors = [];
                // this.errors.push(ValidateField.required('Code', this.inputCode));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Code', this.inputCode));
                this.errors.push(ValidateField.charMinAndMax('Code', this.inputCode, 0, 30));
                this.errors.push(ValidateField.required('Name', this.inputName));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Name', this.inputName));
                this.errors.push(ValidateField.charMinAndMax('Name', this.inputName, 0, 50));
                this.errors.push(ValidateField.wholeNumberFormat('Sequence', this.inputSequence));
                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            create: async function () {
                if(!this.validateForm()) {
                    var colorFamilyPayload = {
                        colorfamily: {
                            name: this.inputName.trim(),
                            code: this.inputCode.trim(),
                            sequence_no: this.inputSequence,
                            status: 'A',
                            color_id: this.parentId
                        }
                    }
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'color_families', null, colorFamilyPayload)
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                if(!this.validateForm()) {
                    var colorFamilyPayload = {
                        colorfamily: {
                            name: this.inputName.trim(),
                            code: this.inputCode.trim(),
                            sequence_no: this.inputSequence,
                            status: 'A',
                            color_id: this.parentId
                        }
                    }
                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'color_families/' + this.profileId, null, colorFamilyPayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            }
        }
    }
</script>

<style>
</style>
